import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "src/environments/environment";
import { calcularValorAdesao } from "src/utils/adesao.utils";
import { Sale } from "../models/sale";
import { SalesService } from "../services/sales.service";
import { Beneficiary } from "../models/beneficiary";
import { Observable } from "rxjs";
import { FormControl } from "@angular/forms";
import { startWith, map } from "rxjs/operators";
import { ProductItem } from "../models/product-item";
import { LoaderService } from "src/app/loader/loader.service";
import * as moment from "moment";
import { DatePipe } from "@angular/common";
import { trigger, state, style, transition, animate } from "@angular/animations";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { PermissionsService } from "src/app/services/permissions.service";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { UfSale } from "../models/ufs-sale";
import { CitySale } from "../models/city-sale";
import { NeighborhoodSale } from "../models/neighborhood-sale";
import { CepService } from "src/app/cep.service";
import { IBGECode, IBGECity } from "src/utils/IBGEcode";
import { getSignatureImageUrl, getSignatureUrl, getSignatureStatus } from "../utils/signature.utils";

@Component({
  selector: "app-sales-details",
  templateUrl: "./sales-details.component.html",
  styleUrls: ["./sales-details.component.scss"],
  animations: [
    trigger("rotatedState", [
      state("default", style({ transform: "rotate(0)" })),
      state("rotated90", style({ transform: "rotate(90deg)" })),
      state("rotated180", style({ transform: "rotate(180deg)" })),
      state("rotated270", style({ transform: "rotate(270deg)" })),
      transition("rotated270 => default", animate("400ms ease-out")),
      transition("default => rotated90", animate("400ms ease-out")),
      transition("rotated90 => rotated180", animate("400ms ease-out")),
      transition("rotated180 => rotated270", animate("400ms ease-out")),
    ]),
  ],
})
export class SalesDetailsComponent implements OnInit {
  fromWaitingCustomer: boolean = false;
  env;
  sale: Sale;

  phoneNumber: string;
  statusTitle: string = "...";

  printSummary: boolean = false;

  imageRotateState: string = "default";
  imageUrlExpanded: string;

  beneficiariesPage = 1;
  beneficiariesPageSize = 10;
  beneficiariesCollectionSize = 0;
  beneficiaries$: Observable<Beneficiary[]>;
  beneficiariesFilter = new FormControl("");
  itemsPage = 1;
  itemsPageSize = 10;
  itemsCollectionSize = 0;
  items$: Observable<ProductItem[]>;
  itemsFilter = new FormControl("");
  timeoutIDError;

  @ViewChild("alertError", { read: ElementRef, static: false })
  alertError: ElementRef;

  genres = [
    { label: "Masculino", value: "M" },
    { label: "Feminino", value: "F" },
  ];

  schooling = [
    { value: "1", label: "Não Escolarizado" },
    { value: "2", label: "Ensino Fundamental Incompleto" },
    { value: "3", label: "Ensino Fundamental Completo" },
    { value: "4", label: "Ensino Médio Incompleto" },
    { value: "5", label: "Ensino Médio Completo" },
    { value: "6", label: "Superior Incompleto" },
    { value: "7", label: "Superior Completo" },
    { value: "8", label: "Pós-graduação" },
    { value: "9", label: "Mestrado" },
    { value: "10", label: "Doutorado" },
    { value: "11", label: "Pós-Doutorado" },
  ];

  civilState = [
    { value: "S", label: "Solteiro" },
    { value: "C", label: "Casado" },
    { value: "D", label: "Divorciado" },
    { value: "V", label: "Viúvo" },
    { value: "O", label: "Outros" },
    { value: "J", label: "Junto" },
    { value: "U", label: "União Estável" },
  ];

  neighborhoodDropdownSettings: IDropdownSettings = {};

  cityDropdownSettings: IDropdownSettings = {};

  ufDropdownSettings: IDropdownSettings = {};

  neighborhoodDropdownList: string[];
  neighborhoodDropdownListBilling: string[];

  cityDropdownList: string[];
  cityDropdownListBilling: string[];

  ufDropdownList: string[];

  ufs: UfSale[];

  cities: CitySale[];
  citiesBilling: CitySale[];

  neighborhoods: NeighborhoodSale[];
  neighborhoodsBilling: NeighborhoodSale[];

  neighborhood: NeighborhoodSale;
  neighborhoodBilling: NeighborhoodSale;

  selectData: any;
  selectDataBilling: any;

  canEdit: boolean;

  checkCanEdit: any;

  cepNotFound: boolean = false;
  cepFailed: boolean = false;
  saleRecord: any;

  location = {
    lat: 0,
    lng: 0,
  };

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private salesService: SalesService,
    private loaderService: LoaderService,
    private renderer: Renderer2,
    public modalService: NgbModal,
    public permissionsService: PermissionsService,
    private cepService: CepService
  ) {
    this.env = environment;
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.fromWaitingCustomer = params["fromWaitingCustomer"] === "true";
    });
    this.getSale(this.env.selected.cnpj, this.route.snapshot.paramMap.get("id"));
    this.getUfs(this.env.selected.cnpj);
    this.checkEditSale(this.env.selected.cnpj);
  }

  get telefone(): string {
    return this.sale.titular._telefone;
  }

  set telefone(value: string) {
    this.sale.titular._telefone = this.phoneMask(value);
  }

  phoneMask(phone: string): string {
    phone = phone.replace(/\D/g, "");

    if (phone.length === 10) {
      return phone.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
    } else if (phone.length === 11) {
      return phone.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    } else {
      return phone;
    }
  }

  async checkEditSale(cnpj: string) {
    const loader = await this.loaderService.notifica({
      title: "Buscando parametros de venda...",
      date: moment().toISOString(),
      type: "loading",
    });

    this.checkCanEdit = await this.salesService.getParams(cnpj).toPromise();

    this.canEdit = this.checkCanEdit.editaVenda && (this.sale.status === "aguardando" || this.sale.status === "erro");

    loader.dismiss();
  }
  async getUfs(cnpj: string) {
    const loader = await this.loaderService.notifica({
      title: "Buscando estados...",
      date: moment().toISOString(),
      type: "loading",
    });

    this.ufs = await this.salesService.getUFs(cnpj).toPromise();
    this.setUfDropdown();

    loader.dismiss();
  }

  setNeighborhoodDropdown() {
    this.neighborhoodDropdownList = this.neighborhoods.map(item => item.description);

    this.neighborhoodDropdownSettings = {
      singleSelection: true,
      idField: "bairro",
      textField: "bairro",
      unSelectAllText: "Limpar Seleção",
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Pesquisar",
      noDataAvailablePlaceholderText: "Sem dados disponíveis",
    };
  }
  setNeighborhoodDropdownBilling() {
    this.neighborhoodDropdownListBilling = this.neighborhoodsBilling.map(item => item.description);

    this.neighborhoodDropdownSettings = {
      singleSelection: true,
      idField: "bairro",
      textField: "bairro",
      unSelectAllText: "Limpar Seleção",
      itemsShowLimit: 2,
      allowSearchFilter: true,
      searchPlaceholderText: "Pesquisar",
      noDataAvailablePlaceholderText: "Sem dados disponíveis",
    };
  }
  setCityDropdown() {
    this.cityDropdownList = this.cities.map(item => item.city);

    this.cityDropdownSettings = {
      singleSelection: true,
      idField: "cidade",
      textField: "cidade",
      unSelectAllText: "Limpar Seleção",
      itemsShowLimit: 3,
      allowSearchFilter: true,
      searchPlaceholderText: "Pesquisar",
      noDataAvailablePlaceholderText: "Sem dados disponíveis",
    };
  }
  setCityDropdownBilling() {
    this.cityDropdownListBilling = this.citiesBilling.map(item => item.city);

    this.cityDropdownSettings = {
      singleSelection: true,
      idField: "cidade",
      textField: "cidade",
      unSelectAllText: "Limpar Seleção",
      itemsShowLimit: 3,
      allowSearchFilter: true,
      searchPlaceholderText: "Pesquisar",
      noDataAvailablePlaceholderText: "Sem dados disponíveis",
    };
  }
  setUfDropdown() {
    this.ufDropdownList = this.ufs.map(item => item.uf);

    this.ufDropdownSettings = {
      singleSelection: true,
      idField: "estado",
      textField: "estado",
      unSelectAllText: "Limpar Seleção",
      itemsShowLimit: 3,
      allowSearchFilter: true,
      searchPlaceholderText: "Pesquisar",
      noDataAvailablePlaceholderText: "Sem dados disponíveis",
    };
  }

  async getSale(cnpj: string, id: string) {
    const loader = await this.loaderService.notifica({
      title: "Buscando venda...",
      date: moment().toISOString(),
      type: "loading",
    });

    this.sale = await this.salesService.getSale(cnpj, id).toPromise();
    this.saleRecord = await this.salesService.getSaleRecord(this.sale._id).toPromise().catch(() => null);

    this.location = this.sale.localizacao ? this.sale.localizacao : this.location;

    this.selectData = {
      ufs: this.sale.titular ? [this.sale.titular.estado] : [],
      cities: this.sale.titular ? [this.sale.titular.cidade_nome] : [],
      neighborhoods: this.sale.titular ? [this.sale.titular.bairro] : [],
    };

    if (this.sale.titular && this.sale.titular.endereco_cobranca) {
      this.selectDataBilling = {
        ufs: [this.sale.titular.endereco_cobranca.estado],
        cities: [this.sale.titular.endereco_cobranca.cidade_nome],
        neighborhoods: [this.sale.titular.endereco_cobranca.bairro],
      };
    }

    this.beneficiaries$ = this.beneficiariesFilter.valueChanges.pipe(
      startWith(""),
      map(text => this.beneficiariesSearch(text, this.sale.beneficiarios))
    );

    this.items$ = this.itemsFilter.valueChanges.pipe(
      startWith(""),
      map(text => this.itemsSearch(text, this.sale.produtos))
    );

    this.getStatus(this.sale);

    loader.dismiss();
  }

  beneficiariesSearch(text: string, beneficiaries: Beneficiary[]): Beneficiary[] {
    const datePipe = new DatePipe("pt");

    const beneficiariesFiltered: Beneficiary[] = beneficiaries
      ? beneficiaries.filter(beneficiary => {
          const term = text.toLowerCase();
          return (
            datePipe.transform(beneficiary.nascimento, "dd/MM/yyyy").includes(term) ||
            beneficiary.nome.toLowerCase().includes(term) ||
            beneficiary.cpf.toLowerCase().includes(term) ||
            (beneficiary.telefone || "").toLowerCase().includes(term) ||
            (beneficiary.email || "").toLowerCase().includes(term) ||
            beneficiary.seguro_nome.toLowerCase().includes(term) ||
            this.getGenre(beneficiary.sexo).toLowerCase().includes(term) ||
            this.getRelatives(beneficiary.parentesco).toLowerCase().includes(term) ||
            this.getCivilState(beneficiary.estado_civil).toLowerCase().includes(term)
          );
        })
      : [];

    this.beneficiariesPage = 1;
    this.beneficiariesCollectionSize = beneficiariesFiltered.length;

    return beneficiariesFiltered;
  }

  itemsSearch(text: string, items: ProductItem[]): ProductItem[] {
    const itemsFiltered: ProductItem[] = items
      ? items.filter(item => {
          const term = text.toLowerCase();
          return (
            item.codigo.toLowerCase().includes(term) ||
            item.descricao.toLowerCase().includes(term) ||
            item.preco.toString().toLowerCase().includes(term) ||
            item.quantidade.toString().toLowerCase().includes(term)
          );
        })
      : [];

    this.itemsPage = 1;
    this.itemsCollectionSize = itemsFiltered.length;

    return itemsFiltered;
  }

  private getStatus({ status }: Sale) {
    status = status ? status.toLowerCase() : status;

    switch (status) {
      case "sincronizado":
        this.statusTitle = "Sincronizado";
        break;
      case "aprovado":
        this.statusTitle = "Aprovado";
        break;
      case "aguardando":
        if (!this.fromWaitingCustomer) {
          this.statusTitle = "Aguardando Aprovação";
          break;
        } else {
          this.statusTitle = "Aguardando Cliente";
          break;
        }
      case "devolvido":
        this.statusTitle = "Devolvido";
        break;
      case "aguardando_pagamento":
        this.statusTitle = "Aguardando Pagamento";
        break;

      default:
        this.statusTitle = "Erro";
        break;
    }
  }

  getGenre(genre: string) {
    switch (genre) {
      case "M":
        return "Masculino";
      case "F":
        return "Feminino";

      default:
        return "";
    }
  }

  getCivilState(state: string) {
    switch (state) {
      case "S":
        return "Solteiro";
      case "C":
        return "Casado";
      case "D":
        return "Divorciado";
      case "V":
        return "Viúvo";
      case "O":
        return "Outros";
      case "J":
        return "Junto";
      case "U":
        return "União Estável";

      default:
        return "";
    }
  }

  getSaleType(type: string) {
    switch (type) {
      case "1":
        return "Venda";
      case "2":
        return "Portabilidade";
      case "3":
        return "Reativação";

      default:
        return "";
    }
  }

  getSchooling(type: string) {
    switch (type) {
      case "1":
        return "Não Escolarizado";
      case "2":
        return "Ensino Fundamental Incompleto";
      case "3":
        return "Ensino Fundamental Completo";
      case "4":
        return "Ensino Médio Incompleto";
      case "5":
        return "Ensino Médio Completo";
      case "6":
        return "Superior Incompleto";
      case "7":
        return "Superior Completo";
      case "8":
        return "Pós-graduação";
      case "9":
        return "Mestrado";
      case "10":
        return "Doutorado";
      case "11":
        return "Pós-Doutorado";

      default:
        return "";
    }
  }

  getRelatives(type: string) {
    switch (type) {
      case "CO":
        return "Cônjuge";
      case "FI":
        return "Filho(a)";
      case "IR":
        return "Irmão(a)";
      case "NE":
        return "Neto(a)";
      case "PA":
        return "Pai";
      case "MA":
        return "Mãe";
      case "OU":
        return "Outros";
      case "SO":
        return "Sogro(a)";
      case "SC":
        return "Segundo cônjuge";
      case "TU":
        return "Tutelado(a)";
      case "CU":
        return "Curatela";
      case "EN":
        return "Entiado(a)";
      case "AG":
        return "Agregado(a)";

      default:
        return "";
    }
  }

  getDependentType(type: string) {
    switch (type) {
      case "1":
        return "Beneficiário";
      case "2":
        return "Agregado";
      case "3":
        return "Títular";

      default:
        return "";
    }
  }

  async updateSale(status: string, motivo?: string) {
    const loader = await this.loaderService.notifica({
      title: "Atualizando venda...",
      date: moment().toISOString(),
      type: "loading",
    });

    try {
      const updatedSale = await this.salesService.updateSale(this.sale, status, motivo).toPromise();

      if ("error" in updatedSale) {
        this.addErrorAlert(updatedSale.error);
      } else {
        this.router.navigateByUrl(`/sales/${this.env.selected.cnpj}`);
      }
    } catch (err) {
      this.addErrorAlert("Erro ao atualizar a venda. Tente novamente.");
    } finally {
      loader.dismiss();
    }
  }

  evaluatePayments(evalPayModal: NgbModal) {
    const adesaoCC =
      this.sale.adesao &&
      this.sale.adesao.forma_de_pagamento &&
      this.sale.adesao.forma_de_pagamento.includes("CC") &&
      this.sale.adesao.nsu != "";
    const adiantamentoCC =
      this.sale.adiantamento &&
      this.sale.adiantamento.forma_de_pagamento &&
      this.sale.adiantamento.forma_de_pagamento.includes("CC") &&
      this.sale.adiantamento.nsu != "";

    if (adesaoCC || adiantamentoCC) {
      this.modalService.open(evalPayModal, { size: "lg", centered: true });
    } else {
      this.updateSale("deletado", this.sale.motivo_deletado);
    }
  }

  addErrorAlert(msg: string) {
    clearTimeout(this.timeoutIDError);

    this.renderer.setProperty(this.alertError.nativeElement, "innerHTML", msg);
    this.renderer.setProperty(this.alertError.nativeElement, "hidden", false);

    this.timeoutIDError = setTimeout(_ => {
      this.renderer.setProperty(this.alertError.nativeElement, "hidden", true);
    }, 8000);
  }

  onExpandImage(imageUrl: string) {
    this.imageUrlExpanded = imageUrl;
  }

  imageRotate(state?: string) {
    if (state) {
      this.imageRotateState = state;
    } else {
      switch (this.imageRotateState) {
        case "default":
          this.imageRotateState = "rotated90";
          break;
        case "rotated90":
          this.imageRotateState = "rotated180";
          break;
        case "rotated180":
          this.imageRotateState = "rotated270";
          break;
        case "rotated270":
          this.imageRotateState = "default";
          break;

        default:
          this.imageRotateState = "default";
          break;
      }
    }
  }
  printSaleSummary() {
    this.printSummary = true;
  }

  goSales(): void {
    this.router.navigateByUrl(`/sales/${this.env.selected.cnpj}`);
  }

  private updateMunicipio() {
    if (this.sale.titular.estado && this.sale.titular.cidade_nome) {
      const codigoIBGE = IBGECode(this.sale.titular.estado, this.sale.titular.cidade_nome);
      this.sale.titular.municipio = codigoIBGE;
    }
  }

  ufChangeEvent(uf: any) {
    const selectedUf = Array.isArray(uf) ? uf[0] : uf;

    if (!selectedUf) {
      this.sale.titular.estado = "";
      this.cities = [];
      this.neighborhoods = [];
      this.sale.titular.cidade_nome = "";
      this.sale.titular.bairro = "";
      this.sale.titular.municipio = "";
      this.sale.titular.codigo_do_bairro = "";
      this.selectData.cities = [];
      this.selectData.neighborhoods = [];
      return;
    }
    // Atualiza UF do endereço principal
    this.sale.titular.estado = selectedUf;
    this.salesService.getCities(this.env.selected.cnpj, selectedUf).subscribe((cities: CitySale[]) => {
      this.cities = cities;
      this.setCityDropdown();
      this.updateMunicipio();
    });
  }

  cityChangeEvent(city: string) {
    const selectedCity = Array.isArray(city) ? city[0] : city;
    if (!selectedCity) {
      this.sale.titular.cidade_nome = "";
      this.cities = [];
      this.neighborhoods = [];
      this.sale.titular.municipio = "";
      this.sale.titular.codigo_do_bairro = "";
      this.selectData.neighborhoods = [];
      return;
    }
    this.sale.titular.cidade_nome = selectedCity;
    this.salesService.getNeighborhood(this.env.selected.cnpj, selectedCity).subscribe((e: NeighborhoodSale[]) => {
      this.neighborhoods = e;
      this.setNeighborhoodDropdown();
      this.updateMunicipio();
    });
  }

  neighborhoodChangeEvent(neighborhood: any) {
    const selectedNeighborhood = Array.isArray(neighborhood) ? neighborhood[0] : neighborhood;
    if (!selectedNeighborhood) {
      this.sale.titular.bairro = "";
      this.neighborhood = undefined;
      this.sale.titular.codigo_do_bairro = "";
      return;
    }
    this.sale.titular.bairro = selectedNeighborhood;
    this.neighborhood = this.neighborhoods.find(e => e.description === selectedNeighborhood);
    if (this.neighborhood && this.neighborhood.code) {
      this.sale.titular.codigo_do_bairro = this.neighborhood.code;
    }
  }

  private updateMunicipioBilling() {
    if (
      this.sale.titular.endereco_cobranca &&
      this.sale.titular.endereco_cobranca.estado &&
      this.sale.titular.endereco_cobranca.cidade_nome
    ) {
      const codigoIBGE = IBGECode(
        this.sale.titular.endereco_cobranca.estado,
        this.sale.titular.endereco_cobranca.cidade_nome
      );
      this.sale.titular.endereco_cobranca.municipio = codigoIBGE;
    }
  }

  // Eventos de alteração para o endereço de cobrança
  ufBillingChangeEvent(uf: string) {
    if (!this.sale.titular.endereco_cobranca) return;
    const selectedUf = Array.isArray(uf) ? uf[0] : uf;
    if (!selectedUf) {
      this.sale.titular.endereco_cobranca.estado = "";
      this.citiesBilling = [];
      this.neighborhoodsBilling = [];
      this.sale.titular.endereco_cobranca.cidade_nome = "";
      this.sale.titular.endereco_cobranca.bairro = "";
      this.sale.titular.endereco_cobranca.municipio = "";
      this.sale.titular.endereco_cobranca.codigo_do_bairro = "";
      this.selectDataBilling.cities = [];
      this.selectDataBilling.neighborhoods = [];

      return;
    }
    this.sale.titular.endereco_cobranca.estado = selectedUf;
    this.salesService.getCities(this.env.selected.cnpj, selectedUf).subscribe((cities: CitySale[]) => {
      this.citiesBilling = cities;
      this.setCityDropdownBilling();
      this.updateMunicipioBilling();
    });
  }

  cityBillingChangeEvent(city: string) {
    if (!this.sale.titular.endereco_cobranca) return;
    const selectedCity = Array.isArray(city) ? city[0] : city;
    if (!selectedCity) {
      this.sale.titular.endereco_cobranca.cidade_nome = "";
      this.citiesBilling = [];
      this.neighborhoodsBilling = [];
      this.sale.titular.endereco_cobranca.municipio = "";
      this.sale.titular.endereco_cobranca.codigo_do_bairro = "";
      this.selectDataBilling.neighborhoods = [];
      return;
    }
    this.sale.titular.endereco_cobranca.cidade_nome = selectedCity;
    this.salesService.getNeighborhood(this.env.selected.cnpj, selectedCity).subscribe((e: NeighborhoodSale[]) => {
      this.neighborhoodsBilling = e;
      this.setNeighborhoodDropdownBilling();
      this.updateMunicipioBilling();
    });
  }

  neighborhoodBillingChangeEvent(neighborhood: any) {
    if (!this.sale.titular.endereco_cobranca) return;
    const selectedNeighborhood = Array.isArray(neighborhood) ? neighborhood[0] : neighborhood;
    if (!selectedNeighborhood) {
      this.sale.titular.endereco_cobranca.bairro = "";
      this.neighborhoodBilling = undefined;
      this.sale.titular.endereco_cobranca.codigo_do_bairro = "";
      return;
    }
    this.sale.titular.endereco_cobranca.bairro = selectedNeighborhood;
    this.neighborhoodBilling = this.neighborhoodsBilling
      ? this.neighborhoodsBilling.find(e => e.description === selectedNeighborhood)
      : undefined;
    if (this.neighborhoodBilling && this.neighborhoodBilling.code) {
      this.sale.titular.endereco_cobranca.codigo_do_bairro = this.neighborhoodBilling.code;
    }
  }

  goBack(): void {
    this.router.navigateByUrl(`/salesmodule/${this.env.selected.cnpj}`);
  }

  searchCep(cep: string) {
    const code = (cep || "").replace(/\D/g, "");
    if (!code) return;

    this.cepService.getCepInfo(code).subscribe(
      data => {
        if (data.erro) {
          this.cepNotFound = true;
          return;
        }
        this.cepNotFound = false;
        this.cepFailed = false;

        const uf = data.uf ? data.uf.toUpperCase() : "";
        const localidade = data.localidade
          ? data.localidade
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toUpperCase()
          : "";
        const bairro = data.bairro
          ? data.bairro
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toUpperCase()
          : "";
        const codigo_do_bairro = data.codigo_do_bairro
          ? data.bairro
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toUpperCase()
          : "";
        const logradouro = data.logradouro
          ? data.logradouro
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toUpperCase()
          : "";

        if (!this.sale) this.sale = {} as any;
        if (!this.sale.titular) this.sale.titular = {} as any;

        this.sale.titular.endereco = logradouro;
        if (uf) this.sale.titular.estado = uf;
        if (localidade) this.sale.titular.cidade_nome = localidade;
        if (bairro) this.sale.titular.bairro = bairro;
        if (codigo_do_bairro) this.sale.titular.codigo_do_bairro = codigo_do_bairro;

        this.selectData = this.selectData || {};
        this.selectData.ufs = uf ? [uf] : [];
        this.selectData.cities = localidade ? [localidade] : [];
        this.selectData.neighborhoods = bairro ? [bairro] : [];

        this.updateMunicipio();
      },
      _ => {
        this.cepFailed = true;
      }
    );
  }

  searchBillingCep(cep: string) {
    const code = (cep || "").replace(/\D/g, "");
    if (!code) return;

    this.cepService.getCepInfo(code).subscribe(
      data => {
        if (data.erro) {
          this.cepNotFound = true;
          return;
        }
        this.cepNotFound = false;
        this.cepFailed = false;

        const uf = data.uf ? data.uf.toUpperCase() : "";
        const localidade = data.localidade
          ? data.localidade
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toUpperCase()
          : "";
        const bairro = data.bairro
          ? data.bairro
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toUpperCase()
          : "";
        const logradouro = data.logradouro
          ? data.logradouro
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toUpperCase()
          : "";

        if (!this.sale) this.sale = {} as any;
        if (!this.sale.titular) this.sale.titular = {} as any;
        if (!this.sale.titular.endereco_cobranca) this.sale.titular.endereco_cobranca = {} as any;

        this.sale.titular.endereco_cobranca.endereco = logradouro;
        if (uf) this.sale.titular.endereco_cobranca.estado = uf;
        if (localidade) this.sale.titular.endereco_cobranca.cidade_nome = localidade;
        if (bairro) this.sale.titular.endereco_cobranca.bairro = bairro;

        this.selectDataBilling = this.selectDataBilling || {};
        this.selectDataBilling.ufs = uf ? [uf] : [];
        this.selectDataBilling.cities = localidade ? [localidade] : [];
        this.selectDataBilling.neighborhoods = bairro ? [bairro] : [];

        this.updateMunicipioBilling();
      },
      _ => {
        this.cepFailed = true;
      }
    );
  }

  // Transação de verificação do cartão da recorrência (DTGD-1530): exibe a
  // última tentativa registrada pelo app de vendas.
  getLastCardVerification(): { label: string; badge: string; dataHora: string } | null {
    const verificacoes = this.sale && (this.sale as any).verificacoes_cartao;
    if (!verificacoes || !verificacoes.length) {
      return null;
    }
    const ultima = verificacoes[verificacoes.length - 1];
    const visual = {
      aprovada: { label: "Verificado", badge: "badge-success" },
      recusada: { label: "Recusado", badge: "badge-danger" },
    }[ultima.resultado] || { label: "Erro na verificação", badge: "badge-warning" };
    return { ...visual, dataHora: ultima.data_hora };
  }

  getSignatureDisplay(): string {
    if (this.getSignatureImageUrl()) {
      return "imagem";
    }

    if (this.getSignatureUrl()) {
      return "link";
    }

    return this.saleRecord === undefined ? "" : "indisponivel";
  }

  getSignatureImageUrl(): string {
    return getSignatureImageUrl(this.sale);
  }

  getSignatureUrl(): string {
    return getSignatureUrl(this.saleRecord);
  }

  getSignatureStatus(): string {
    return getSignatureStatus(this.saleRecord);
  }

  getValorAdesao(): number {
    const adesao = this.sale && this.sale.adesao;
    return calcularValorAdesao(adesao && adesao.valor, adesao && adesao.desconto);
  }
}
